import React, { useState } from "react";
import styled from "styled-components";

export default function DonateByEmail() {
  // Gmail address associated with PayPal
  const PAYPAL_EMAIL =
    process.env.REACT_APP_PAYPAL_GMAIL || "isrhbmelbourne@gmail.com";

  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(PAYPAL_EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      alert("Please copy the email manually.");
    }
  };

  const openPayPal = () => {
    window.open(
      "https://www.paypal.com/myaccount/transfer/homepage",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Wrapper id="donate">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font30 extraBold">
              You are a part of the community. Therefore, donating to the
              community means donating to yourself. You are investing in your
              future generations.
            </h1>
            <SubText>
              To donate, please send money via PayPal to the email address
              below.
            </SubText>
          </HeaderInfo>

          <Card>
            <SectionTitle>PayPal recipient email</SectionTitle>

            <EmailBox>
              <EmailText>{PAYPAL_EMAIL}</EmailText>

              <Actions>
                <PrimaryButton type="button" onClick={copyEmail}>
                  {copied ? "Email copied ✓" : "Copy email"}
                </PrimaryButton>

                <OutlineButton type="button" onClick={openPayPal}>
                  Open PayPal
                </OutlineButton>
              </Actions>
            </EmailBox>

            <Instructions>
              <ol>
                <li>Open PayPal and sign in to your account.</li>
                <li>
                  Click <strong>Send</strong> or <strong>Send money</strong>.
                </li>
                <li>
                  Paste the recipient email:
                  <strong> {PAYPAL_EMAIL}</strong>
                </li>
                <li>Enter the amount you wish to donate and confirm.</li>
              </ol>
            </Instructions>

            <Disclaimer>
              <strong>Important:</strong> Please double-check the recipient
              email before sending. Payments sent to the wrong email address may
              not be recoverable. PayPal may deduct transaction fees depending
              on your country and payment method.
            </Disclaimer>
          </Card>

          <Spacer />
        </div>
      </div>
    </Wrapper>
  );
}

/* ========== styles ========== */

const Wrapper = styled.section`
  width: 100%;
`;

const HeaderInfo = styled.div`
  padding: 70px 0 20px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const SubText = styled.p`
  margin-top: 10px;
  color: #6b7280;
  line-height: 1.5;
`;

const Card = styled.div`
  max-width: 680px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 20px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
`;

const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 900;
  margin-bottom: 10px;
  color: #111827;
`;

const EmailBox = styled.div`
  padding: 16px;
  border-radius: 16px;
  background: #f9fafb;
  border: 1px solid #eef2f7;
  text-align: center;
`;

const EmailText = styled.div`
  font-size: 18px;
  font-weight: 900;
  color: #111827;
  word-break: break-all;
  margin-bottom: 12px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const PrimaryButton = styled.button`
  padding: 10px 16px;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  font-weight: 900;
  background: #111827;
  color: #ffffff;
`;

const OutlineButton = styled.button`
  padding: 10px 16px;
  border-radius: 9999px;
  border: 1px solid #d1d5db;
  cursor: pointer;
  font-weight: 900;
  background: #ffffff;
  color: #111827;
`;

const Instructions = styled.div`
  margin-top: 14px;
  font-size: 14px;
  color: #374151;
  line-height: 1.55;

  ol {
    padding-left: 18px;
  }

  li {
    margin: 6px 0;
  }
`;

const Disclaimer = styled.p`
  margin-top: 14px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.45;

  strong {
    color: #374151;
  }
`;

const Spacer = styled.div`
  height: 60px;
`;
